import { gql } from '@apollo/client';

export const fetchRecentlyGeneratedInvoicesForHomePageInPPC = gql`
  query fetchRecentlyGeneratedInvoicesForHomePageInPPC(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: InvoicesFilterOptions
  ) {
    transactionAccount(id: $id) {
      id
      invoices(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        nodes {
          id
          transactionAccountId
          invoiceNumber
          createdTimestamp
          shipTo {
            id
            fullName
          }
          paymentCurrency
          total
          appliedBalance
        }
      }
    }
  }
`;
